/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type JsonValueKind = 'Undefined' | 'Object' | 'Array' | 'String' | 'Number' | 'True' | 'False' | 'Null';

export const JsonValueKind = {
    Undefined: 'Undefined' as JsonValueKind,
    Object: 'Object' as JsonValueKind,
    Array: 'Array' as JsonValueKind,
    String: 'String' as JsonValueKind,
    Number: 'Number' as JsonValueKind,
    True: 'True' as JsonValueKind,
    False: 'False' as JsonValueKind,
    Null: 'Null' as JsonValueKind
};

